import jeep from "../img/jeep-wrap-1.png"
import mustang from "../img/mustang-wrap-1.jpg"
import truck from "../img/truck-wrap-1.jpeg"
import porche from "../img/porche-wrap-1.jpeg"
import kidsWall from "../img/wallwrapcopy.jpg"
import calState from "../img/calStateTruck.jpeg"
import rooterDoc from "../img/theRooterDoctor.jpeg"

export const Images = [
    { img: jeep, type: "Color", alt: "Jeep Color Wrap" },
    { img: mustang, type: "Commercial", alt: "Mustang Commercial Wrap" },
    { img: truck, type: "Commercial", alt: "Truck Commercial Wrap" },
    { img: porche, type: "Color", alt: "Porche white Wrap" },
    { img: kidsWall, type: "Wall", alt: "Animal Map" },
    { img: calState, type: "Commercial", alt: "CalState Truck" },
    { img: rooterDoc, type: "Commercial", alt: "rooter doctor van" }
]

export const CarouselImages = [
    { image: jeep }, { image: mustang }, { image: truck }, { image: porche }
]

// { img: kidsWall, type: "Wall", alt: "Animal Map" }